document.addEventListener('DOMContentLoaded', () => {
  const section = document.querySelector('.section-multicard');
  if (!section) return;

  const cards = section.querySelectorAll('.multirow-card');
  if (!cards.length) return;

  // ✅ Activate first card by default
  cards[0].classList.add('is-active');

  cards.forEach(card => {
    const toggle = card.querySelector('.mobile-card-toggle');
    if (!toggle) return;

  toggle.addEventListener('click', () => {
  if (window.innerWidth >= 750) return;

  const isOpen = card.classList.contains('is-active');

  cards.forEach(c => c.classList.remove('is-active'));

  if (!isOpen) {
    card.classList.add('is-active');

    // ✅ FIX: scroll active card into view
    setTimeout(() => {
            const cardTop = card.getBoundingClientRect().top + window.pageYOffset;
    const header = document.querySelector('.section-header');
const headerHeight = header ? header.offsetHeight : 0;

window.scrollTo({
  top: cardTop - headerHeight - 12,
  behavior: 'smooth'
});
    }, 100);
  }
});

  });
});
